/* eslint-disable */

import moment from 'moment'
// @ts-ignore
import de from 'moment/locale/de'
// @ts-ignore
import en from 'moment/locale/en-gb'
// @ts-ignore
import fr from 'moment/locale/fr'
// @ts-ignore
import it from 'moment/locale/it'
// @ts-ignore
import es from 'moment/locale/es'
// @ts-ignore
import pt from 'moment/locale/pt'
// @ts-ignore
import ja from 'moment/locale/ja'
// @ts-ignore
import ar from 'moment/locale/ar'
// @ts-ignore
import zhCn from 'moment/locale/zh-cn'
// @ts-ignore
import ko from 'moment/locale/ko'
// @ts-ignore
import th from 'moment/locale/th'
// @ts-ignore
import zhHk from 'moment/locale/zh-hk'

import type { SupportedLanguage } from 'featureSliced/shared/utils/localization/i18n'

/**
 * Each `moment/locale/X` import above SETS moment's GLOBAL locale as a side
 * effect (last import wins), so this function must be called once at boot
 * (i18n.ts) and on every language switch (languageSideEffectsMiddleware) to
 * pin the global locale to the UI language. `updateLocale` only re-sets the
 * global locale while its second argument is non-null — keep passing the
 * imported bindings, do not turn these into side-effect-only imports.
 */
export const updateMomentLanguage = (lang: SupportedLanguage) => {
  switch (lang) {
    case 'en':
      moment.updateLocale('en', en)
      break
    case 'fr':
      moment.updateLocale('fr', fr)
      break
    case 'it':
      moment.updateLocale('it', it)
      break
    case 'es':
      moment.updateLocale('es', es)
      break
    case 'pt':
      moment.updateLocale('pt', pt)
      break
    case 'ja':
      moment.updateLocale('ja', ja)
      break
    case 'ar':
      moment.updateLocale('ar', ar)
      break
    case 'zh':
      moment.updateLocale('zh-cn', zhCn)
      break
    case 'ko':
      moment.updateLocale('ko', ko)
      break
    case 'th':
      moment.updateLocale('th', th)
      break
    case 'zh-HK':
      moment.updateLocale('zh-hk', zhHk)
      break
    default:
      moment.updateLocale('de', de)
      break
  }
}
